import { Component, ElementRef, ChangeDetectorRef, EventEmitter, HostListener, OnDestroy, OnInit, Output, ViewEncapsulation, signal } from '@angular/core'
import { Router } from '@angular/router'
import { ValidatorService } from '../../../common/utilities/validator.service'
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { UserInputService } from 'src/app/common/api/services/user-input.service'
import { ProgressiveProfileService } from 'src/app/common/api/services/progressive-profile.service'
import { DatePipe, ViewportScroller, NgClass, AsyncPipe } from '@angular/common'
import { GtmImplementation } from 'src/app/common/api/services/gtmImplementation'
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter'
import { MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core'
import moment from 'moment'
import { ReplaySubject } from 'rxjs'
import { WIRService } from 'src/app/common/api/services/wir.service'
import { admissionTestNamesContent } from '../../../common/json/admission-test-names'
import { FormFieldHelperService } from 'src/app/common/utilities/form-field-helper.service'
import { academicDetailsContent } from '../../../common/json/academic-details-content'
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatSelectSearchComponent } from 'ngx-mat-select-search';
import { MatInput } from '@angular/material/input';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker, MatDatepickerActions, MatDatepickerCancel, MatDatepickerApply } from '@angular/material/datepicker';

export const MY_DATE_FORMAT2 = {
  parse: {
    dateInput: 'DD/MM/YYYY'
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
}

@Component({
    selector: 'app-academic-details',
    templateUrl: './academic-details.component.html',
    styleUrls: ['./academic-details.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT2 },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] }
    ],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, NgClass, MatSelect, MatOption, MatSelectSearchComponent, MatInput, MatChipListbox, MatChipOption, MatDatepickerInput, MatSuffix, MatDatepickerToggle, MatDatepicker, MatDatepickerActions, MatDatepickerCancel, MatDatepickerApply, AsyncPipe]
})
export class AcademicDetailsComponent implements OnInit, OnDestroy {
  questions: any
  academicDetailsForm: any
  officeDetails: any
  selectedLanguage: any
  academicDetailsNotValid: boolean = false
  showLoader = signal(false)
  submitted: any
  invalidStartDate: boolean = false
  invalidEndDate: boolean = false
  invalidTestDate: boolean = false
  futureStartDate: boolean = false
  futureTestDate: boolean = false
  startDateAfterEndDate: boolean = false
  endDateBeforeStartDate: boolean = false
  yesterdayDate = moment().subtract(1, 'day')
  todayDate = moment()
  searchFilters: { [key: string]: FormControl } = {}
  filteredOptions: { [key: string]: ReplaySubject<any[]> } = {}
  allOptions: { [key: string]: any[] } = {}
  showInstitution = signal(false)
  showQualificationType = signal(false)
  showExamBoard = signal(false)
  showGradeType = signal(false)
  showFinalGrade = signal(false)
  showOtherInstitution = signal(false)
  showHonoursAndPassScore = signal(false)
  showApplicableGrade = signal(false)
  passScoreAttributeId: number = 0

  showTestDate = signal(false)
  showOverallScore = signal(false)
  admissionTestFieldsRequired: boolean = false
  showMajorSubjects = signal(false)
  isUgQualification: boolean = false
  isPgQualification: boolean = false
  selectedStudyCountryCode: string = ''
  private readonly HONOURS_ELIGIBLE_COUNTRIES = ['BGD', 'IND', 'MYS', 'PAK', 'SGP', 'GBR']
  private readonly PASS_SCORE_ELIGIBLE_COUNTRIES = ['IND']
  gradeInputType: 'input' | 'dropdown' | null = null
  gradeInputConfig: any = null
  testScoreConfig: any = null
  admissionTestNames: any[] = admissionTestNamesContent
  country: any
  defaultLanguage = 'EN'
  pageHeaderText: any
  infoTooltipText: any
  otherTestNameText: any
  invalidDateText: any
  pastDateText: any
  startAfterEndText: any
  endBeforeStartText: any
  backText: any
  nextText: any
  cancelText: any
  applyText: any
  optionalText: any
  testDetailsText: any
  validScoreBetweenText: any
  andText: any
  onlyNumbersAllowedText: any
  datePlaceholderText: any
  institutionPassScoreText: any
  honoursDegreeText: any
  yesText: any
  noText: any
  applicableGradeLabel: string = ''
  applicableGradeHelpText: string = ''
  applicableGradeMandatory: boolean = true
  honoursDegreeHelpText: string = ''
  honoursDegreeMandatory: boolean = true
  honoursQuestion: any = null
  applicableGradeQuestion: any = null
  academicTestText: any
  @Output() nextClicked = new EventEmitter<void>()
  @Output() backClicked = new EventEmitter<void>()
  @Output() dataLoaded = new EventEmitter<void>()
  isExistingUser: boolean = false
  private _isRefDataLoading: boolean = false
  get isRefDataLoading (): boolean { return this._isRefDataLoading }
  set isRefDataLoading (value: boolean) {
    const wasLoading = this._isRefDataLoading
    this._isRefDataLoading = value
    if (wasLoading && !value) {
      this.dataLoaded.emit()
    }
  }

  constructor (
    public route: Router,
    public fb: FormBuilder,
    public userInputService: UserInputService,
    public viewPortScroller: ViewportScroller,
    public validatorService: ValidatorService,
    public gtmImplementation: GtmImplementation,
    public ProgressiveProfileQuestionsService: ProgressiveProfileService,
    public wirService: WIRService,
    private el: ElementRef,
    public datePipe: DatePipe,
    private formFieldHelper: FormFieldHelperService,
    private cdr: ChangeDetectorRef
  ) {
    this.academicDetailsForm = this.fb.group({})
  }

  showScrollBtnAcademic: boolean = false
  isScrollingAcademic: boolean = false
  private scrollTimer: any = null
 
  @HostListener('window:scroll')
  onWindowScroll (): void {
    this.showScrollBtnAcademic = window.scrollY > 50
    this.isScrollingAcademic = true
    this.cdr.detectChanges()
    clearTimeout(this.scrollTimer)
    this.scrollTimer = setTimeout(() => { 
      this.isScrollingAcademic = false
      this.cdr.detectChanges()
    }, 300)
  }

  ngOnInit (): void {
    this.viewPortScroller.scrollToPosition([0, 0])
    this.gtmImplementation.pageView('academic_details', 'signed_in_user', 'user_registration')
    this.selectedLanguage = localStorage.getItem('languageSelected') ? localStorage.getItem('languageSelected') : 'EN'
    const sfResponse: any = localStorage.getItem('sfResponse')
    const officeDetails: any = JSON.parse(sfResponse)
    this.country = officeDetails?.wir_country_code
    this.isExistingUser = localStorage.getItem('isExistingUser') === 'true'
    this.getLanguageContent(this.selectedLanguage)
    this.getProgressiveProfileQstns()
  }

  getLanguageContent (language: any): any {
    if (language === 'EN') {
      this.pageHeaderText = academicDetailsContent[language]?.pageHeader
      this.infoTooltipText = academicDetailsContent[language]?.infoTooltip
      this.otherTestNameText = academicDetailsContent[language]?.otherTestName
      this.invalidDateText = academicDetailsContent[language]?.invalidDate
      this.pastDateText = academicDetailsContent[language]?.pastDate
      this.startAfterEndText = academicDetailsContent[language]?.startAfterEnd
      this.endBeforeStartText = academicDetailsContent[language]?.endBeforeStart
      this.backText = academicDetailsContent[language]?.back
      this.nextText = academicDetailsContent[language]?.next
      this.cancelText = academicDetailsContent[language]?.cancel
      this.applyText = academicDetailsContent[language]?.apply
      this.optionalText = academicDetailsContent[language]?.optional
      this.testDetailsText = academicDetailsContent[language]?.testDetails
      this.validScoreBetweenText = academicDetailsContent[language]?.validScoreBetween
      this.andText = academicDetailsContent[language]?.and
      this.onlyNumbersAllowedText = academicDetailsContent[language]?.onlyNumbersAllowed
      this.datePlaceholderText = academicDetailsContent[language]?.datePlaceholder
      this.institutionPassScoreText = academicDetailsContent[language]?.institutionPassScore
      this.honoursDegreeText = academicDetailsContent[language]?.honoursDegree
      this.yesText = academicDetailsContent[language]?.yes
      this.noText = academicDetailsContent[language]?.no
      this.academicTestText = academicDetailsContent[language]?.admissionTest
    } else {
      this.pageHeaderText = academicDetailsContent[this.country + '_' + language]?.pageHeader
      this.infoTooltipText = academicDetailsContent[this.country + '_' + language]?.infoTooltip
      this.otherTestNameText = academicDetailsContent[this.country + '_' + language]?.otherTestName
      this.invalidDateText = academicDetailsContent[this.country + '_' + language]?.invalidDate
      this.pastDateText = academicDetailsContent[this.country + '_' + language]?.pastDate
      this.startAfterEndText = academicDetailsContent[this.country + '_' + language]?.startAfterEnd
      this.endBeforeStartText = academicDetailsContent[this.country + '_' + language]?.endBeforeStart
      this.backText = academicDetailsContent[this.country + '_' + language]?.back
      this.nextText = academicDetailsContent[this.country + '_' + language]?.next
      this.cancelText = academicDetailsContent[this.country + '_' + language]?.cancel
      this.applyText = academicDetailsContent[this.country + '_' + language]?.apply
      this.optionalText = academicDetailsContent[this.country + '_' + language]?.optional
      this.testDetailsText = academicDetailsContent[this.country + '_' + language]?.testDetails
      this.validScoreBetweenText = academicDetailsContent[this.country + '_' + language]?.validScoreBetween
      this.andText = academicDetailsContent[this.country + '_' + language]?.and
      this.onlyNumbersAllowedText = academicDetailsContent[this.country + '_' + language]?.onlyNumbersAllowed
      this.datePlaceholderText = academicDetailsContent[this.country + '_' + language]?.datePlaceholder
      this.institutionPassScoreText = academicDetailsContent[this.country + '_' + language]?.institutionPassScore
      this.honoursDegreeText = academicDetailsContent[this.country + '_' + language]?.honoursDegree
      this.yesText = academicDetailsContent[this.country + '_' + language]?.yes
      this.noText = academicDetailsContent[this.country + '_' + language]?.no
      this.academicTestText = academicDetailsContent[this.country + '_' + language]?.admissionTest
    }
  }

  showStartDateTooltip = false
  showEndDateTooltip = false
  showTestDateTooltip = false

  toggleTooltip (event: Event, type: 'startDate' | 'endDate' | 'testDate'): void {
    if (window.innerWidth <= 700) {
      event.stopPropagation()
      if (type === 'startDate') {
        this.showStartDateTooltip = !this.showStartDateTooltip
      } else if (type === 'endDate') {
        this.showEndDateTooltip = !this.showEndDateTooltip
      } else if (type === 'testDate') {
        this.showTestDateTooltip = !this.showTestDateTooltip
      }
    }
  }

  closeTooltip (event: Event, type: 'startDate' | 'endDate' | 'testDate'): void {
    event.stopPropagation()
    if (type === 'startDate') {
      this.showStartDateTooltip = false
    } else if (type === 'endDate') {
      this.showEndDateTooltip = false
    } else if (type === 'testDate') {
      this.showTestDateTooltip = false
    }
  }

  onInputChange (field: string, value: string, event?: any): any {
    const storageKey = this.getStorageKey(field)
    if (event?.selected === false) {
      this.userInputService.deleteValue(storageKey)
      return
    }

    this.userInputService.setValue(storageKey, value)

    if (field === 'testType') {
      this.handleTestTypeChange(value)
    } else if (field === 'studyCountryName') {
      this.handleCountryChange(value)
    } else if (field === 'institutionName') {
      this.handleInstitutionChange(value)
    } else if (field === 'qualificationType') {
      this.handleQualificationChange(value)
    } else if (field === 'examBoardName') {
      this.handleExamBoardChange(value)
    } else if (field === 'gradeType') {
      this.handleGradeTypeChange(value)
    } else if (field === 'isHonoursDegree') {
      this.userInputService.setValue('isHonoursDegree', value)
    } else if (field === 'applicableGrade') {
      this.userInputService.setValue('applicableGrade', value)
    }
  }

  onHonoursChipChange (event: any, value: boolean): void {
    if (event.selected) {
      this.userInputService.setValue('isHonoursDegree', value)
    } else {
      this.userInputService.deleteValue('isHonoursDegree')
    }
  }

  handleTestTypeChange (value: any): void {
    const testName = typeof value === 'string' ? value : (value?.option_desc || value?.option_label)
    const isNotTaken = value?.option_value === 'tt_17' || testName?.toLowerCase() === 'not taken'
    this.updateTestScoreConfig(testName)
    if (!isNotTaken) {
      this.showTestDate.set(true)
      this.showOverallScore.set(true)
      this.restoreTestDateAndScoreValidations()
    } else {
      this.showTestDate.set(false)
      this.showOverallScore.set(false)
      this.formFieldHelper.clearFieldsWithValidators(this.academicDetailsForm, ['testTakenDate', 'overallScore'], 'academic')
      this.invalidTestDate = false
      this.futureTestDate = false
    }
  }

  handleCountryChange (value: any): void {
    const countryValue = typeof value === 'string' ? value : value?.option_value
    const previousCountryValue = this.userInputService.getValue('studyCountryName')
    const previousCountryCode = typeof previousCountryValue === 'string' ? previousCountryValue : previousCountryValue?.option_value
    if (previousCountryCode && previousCountryCode !== countryValue) {
      this.wirService.clearAcademicOptionsByCountry(previousCountryCode)
    }
    this.selectedStudyCountryCode = countryValue || ''
    this.isUgQualification = false
    this.isPgQualification = false
    this.showMajorSubjects.set(false)
    this.clearDependentFields(['institution', 'qualification', 'examBoard', 'gradeType', 'finalGrade'])
    this.fetchCountryValues(countryValue)
  }

  handleInstitutionChange (value: any): void {
    const institutionValue = typeof value === 'string' ? value : value?.option_label
    this.showOtherInstitution.set(institutionValue?.toLowerCase() === 'others')

    const othersControl = this.academicDetailsForm.get('other_institutionName')
    if (this.showOtherInstitution()) {
      const institutionQuestion = this.questions?.find((q: any) => q.mappingField === 'institutionName' && q.displayFormat.value === 'TEXT_BOX')
      if (institutionQuestion?.mandatory) {
        othersControl?.setValidators([Validators.required])
      }
    } else {
      othersControl?.clearValidators()
      othersControl?.setValue('')
      this.userInputService.deleteValue('other_institutionName')
    }
    othersControl?.updateValueAndValidity()
  }

  handleQualificationChange (value: any): void {
    const qualValue = typeof value === 'string' ? value : value?.country_qual_id
    const isUg = typeof value === 'string' ? false : (value?.study_level_id === '1')
    const countryValue = this.getCountryCode()

    this.isUgQualification = isUg
    this.isPgQualification = typeof value === 'string' ? false : (value?.study_level_id === '2')

    if (this.isUgQualification) {
      this.showInstitution.set(false)
      this.showMajorSubjects.set(false)
      this.showOtherInstitution.set(false)
      this.showHonoursAndPassScore.set(false)
      this.academicDetailsForm.get('institutionName')?.clearValidators()
      this.academicDetailsForm.get('institutionName')?.updateValueAndValidity()
      this.academicDetailsForm.get('other_institutionName')?.clearValidators()
      this.academicDetailsForm.get('other_institutionName')?.updateValueAndValidity()
      this.academicDetailsForm.get('majorSubjects')?.clearValidators()
      this.academicDetailsForm.get('majorSubjects')?.updateValueAndValidity()
      this.userInputService.deleteValue('institutionName')
      this.userInputService.deleteValue('other_institutionName')
      this.userInputService.deleteValue('majorSubjects')
      this.academicDetailsForm.get('institutionName')?.setValue('')
      this.academicDetailsForm.get('other_institutionName')?.setValue('')
      this.academicDetailsForm.get('majorSubjects')?.setValue('')
      this.clearHonoursAndPassScoreFields()
    } else {
      this.showInstitution.set(true)
      this.showMajorSubjects.set(true)
      this.showHonoursAndPassScore.set(!this.isUgQualification && this.HONOURS_ELIGIBLE_COUNTRIES.includes(this.selectedStudyCountryCode))
      this.restoreValidatorIfMandatory('institutionName', 'SELECT_BOX')
      this.restoreValidatorIfMandatory('majorSubjects')
      this.restoreApplicableGradeValidator()
      this.restoreBacklogsValidators()
    }

    if (countryValue && qualValue) {
      this.wirService.clearAcademicOptionsByPayload({ country_3_code: countryValue, country_qual_id: qualValue })
    }

    this.clearDependentFields(['examBoard', 'gradeType', 'finalGrade'])
    this.academicDetailsForm.get('examBoardName')?.clearValidators()
    this.academicDetailsForm.get('examBoardName')?.updateValueAndValidity()
    if (countryValue && qualValue) {
      this.fetchExamBoards(countryValue, qualValue)
    }
  }

  handleExamBoardChange (value: any): void {
    const examBoardId = typeof value === 'string' ? value : value?.qual_exam_board_id
    const countryValue = this.getCountryCode()
    const qualValue = this.getQualificationId()

    if (countryValue && qualValue && examBoardId) {
      this.wirService.clearAcademicOptionsByPayload({ country_3_code: countryValue, country_qual_id: qualValue, qual_exam_board_id: examBoardId })
    }

    this.clearDependentFields(['gradeType', 'finalGrade'])
    if (countryValue && qualValue && examBoardId) {
      this.fetchGradeTypes(countryValue, qualValue, examBoardId)
    }
  }

  handleGradeTypeChange (value: any): void {
    const gradeValue = typeof value === 'string' ? value : value?.grade_id
    const gradeTypeCode = typeof value === 'string' ? value : value?.option_value
    const countryValue = this.getCountryCode()
    const qualValue = this.getQualificationId()
    const examBoardId = this.getExamBoardId()

    if (countryValue && qualValue && examBoardId && gradeValue) {
      this.wirService.clearAcademicOptionsByPayload({ country_3_code: countryValue, country_qual_id: qualValue, qual_exam_board_id: examBoardId, grade_id: gradeValue })
    }

    this.clearDependentFields(['finalGrade'])
    this.updateApplicableGradeVisibility(gradeTypeCode)
    if (countryValue && qualValue && gradeValue) {
      this.fetchGradeDetails(countryValue, qualValue, examBoardId || 'GLO', gradeValue)
    }
  }

  private updateApplicableGradeVisibility (gradeTypeCode: string | null): void {
    if (!gradeTypeCode || this.isUgQualification) {
      this.showApplicableGrade.set(false)
      this.clearApplicableGradeField()
      return
    }

    // Pass score only for India + non-UG qualification (study_level_id != 1)
    if (!this.PASS_SCORE_ELIGIBLE_COUNTRIES.includes(this.selectedStudyCountryCode)) {
      this.showApplicableGrade.set(false)
      this.clearApplicableGradeField()
      return
    }

    const code = gradeTypeCode.toLowerCase()
    if (code === 'percentage' || code === 'gpa10pointscale') {
      this.showApplicableGrade.set(true)
      const attrId = code === 'percentage' ? 2194 : 2340
      this.passScoreAttributeId = attrId
      this.applicableGradeQuestion = this.questions?.find((q: any) => q.mappingField === 'applicableGrade' && q.questionAttributeId === attrId) || null
      if (this.applicableGradeQuestion?.mandatory) {
        this.academicDetailsForm.get('applicableGrade')?.setValidators([Validators.required])
      }
      this.academicDetailsForm.get('applicableGrade')?.updateValueAndValidity()
    } else {
      this.showApplicableGrade.set(false)
      this.clearApplicableGradeField()
    }
  }

  private clearApplicableGradeField (): void {
    const control = this.academicDetailsForm.get('applicableGrade')
    control?.clearValidators()
    control?.setValue('')
    control?.markAsUntouched()
    control?.markAsPristine()
    control?.updateValueAndValidity()
    this.userInputService.deleteValue('applicableGrade')
  }

  restoreTestDateAndScoreValidations (): void {
    const testDateQuestion = this.questions?.find((q: any) => q.mappingField === 'testTakenDate' && q.questionAttributeId === 2337)
    const overallScoreQuestion = this.questions?.find((q: any) => q.mappingField === 'overallScore' && q.questionAttributeId === 2336)

    if (testDateQuestion?.mandatory) {
      this.academicDetailsForm.get('testTakenDate')?.setValidators([Validators.required])
      this.academicDetailsForm.get('testTakenDate')?.updateValueAndValidity()
    }
    if (overallScoreQuestion?.mandatory) {
      const testName = this.academicDetailsForm.get('testType')?.value
      const storedTestType = this.userInputService.getValue('academic_testType')
      const isNotTaken = storedTestType?.option_value === 'tt_17' || testName?.toLowerCase() === 'not taken'
      if (testName && !isNotTaken) {
        this.updateTestScoreConfig(testName)
      } else {
        this.academicDetailsForm.get('overallScore')?.setValidators([Validators.required])
        this.academicDetailsForm.get('overallScore')?.updateValueAndValidity()
      }
    } else {
      const testName = this.academicDetailsForm.get('testType')?.value
      const storedTestType = this.userInputService.getValue('academic_testType')
      const isNotTaken = storedTestType?.option_value === 'tt_17' || testName?.toLowerCase() === 'not taken'
      if (testName && !isNotTaken) {
        this.updateTestScoreConfig(testName)
      }
    }
  }

  clearDependentFields (fields: string[]): void {
    fields.forEach(field => {
      switch (field) {
        case 'institution': {
          if (!this.isUgQualification) {
            this.showInstitution.set(false)
            this.showHonoursAndPassScore.set(false)
          }
          this.showOtherInstitution.set(false)
          this.resetFormField('institutionName', 'institutionName')
          this.clearOtherInstitution()
          this.clearHonoursAndPassScoreFields()
          break
        }
        case 'qualification':
          this.showQualificationType.set(false)
          this.resetFormField('qualificationType', 'qualificationType')
          break
        case 'examBoard':
          this.showExamBoard.set(false)
          this.resetFormField('examBoardName', 'examBoardName')
          break
        case 'gradeType':
          this.showGradeType.set(false)
          this.showApplicableGrade.set(false)
          this.resetFormField('gradeType', 'gradeType')
          this.clearApplicableGradeField()
          break
        case 'finalGrade':
          this.showFinalGrade.set(false)
          this.gradeInputType = null
          this.gradeInputConfig = null
          this.resetFormField('finalGrade', 'finalGrade')
          break
      }
    })
  }

  private resetFormField (field: string, storageKey: string): void {
    this.academicDetailsForm.get(field)?.setValue('')
    this.academicDetailsForm.get(field)?.markAsUntouched()
    this.academicDetailsForm.get(field)?.markAsPristine()
    this.userInputService.deleteValue(storageKey)
  }

  private setRequiredValidator (fieldName: string): void {
    this.academicDetailsForm.get(fieldName)?.setValidators([Validators.required])
    this.academicDetailsForm.get(fieldName)?.updateValueAndValidity()
  }

  private restoreValidatorIfMandatory (fieldName: string, displayFormat?: string): void {
    const question = this.questions?.find((q: any) =>
      q.mappingField === fieldName && (!displayFormat || q.displayFormat.value === displayFormat)
    )
    if (question?.mandatory) {
      this.setRequiredValidator(fieldName)
    }
  }

  private clearSelectionCountry (field: string, storageKey: string): void {
    const countryValue = this.userInputService.getValue('studyCountryName')
    const countryCode = typeof countryValue === 'string' ? countryValue : countryValue?.option_value
    if (countryCode) {
      this.wirService.clearAcademicOptionsByCountry(countryCode)
    }
    this.selectedStudyCountryCode = ''
    this.isPgQualification = false
    this.resetFormField(field, storageKey)
    this.showMajorSubjects.set(false)
    this.academicDetailsForm.get('majorSubjects')?.setValue('')
    this.academicDetailsForm.get('majorSubjects')?.markAsUntouched()
    this.academicDetailsForm.get('majorSubjects')?.markAsPristine()
    this.userInputService.deleteValue('majorSubjects')
    this.clearDependentFields(['institution', 'qualification', 'examBoard', 'gradeType', 'finalGrade'])
  }

  private clearSelectionQualification (field: string, storageKey: string): void {
    const countryValue = this.getCountryCode()
    const qualValue = this.getQualificationId()
    if (countryValue && qualValue) {
      this.wirService.clearAcademicOptionsByPayload({ country_3_code: countryValue, country_qual_id: qualValue })
    }
    this.resetFormField(field, storageKey)
    this.showInstitution.set(false)
    this.showOtherInstitution.set(false)
    this.showMajorSubjects.set(false)
    this.showHonoursAndPassScore.set(false)
    this.isUgQualification = false
    this.isPgQualification = false
    this.resetFormField('institutionName', 'institutionName')
    this.clearOtherInstitution()
    this.clearHonoursAndPassScoreFields()
    this.resetFormField('majorSubjects', 'majorSubjects')
    this.clearDependentFields(['examBoard', 'gradeType', 'finalGrade'])
  }

  private clearSelectionInstitution (field: string, storageKey: string): void {
    this.resetFormField(field, storageKey)
    this.showOtherInstitution.set(false)
    this.clearOtherInstitution()
  }

  private clearOtherInstitution (): void {
    const othersControl = this.academicDetailsForm.get('other_institutionName')
    othersControl?.clearValidators()
    othersControl?.setValue('')
    othersControl?.markAsUntouched()
    othersControl?.markAsPristine()
    othersControl?.updateValueAndValidity()
    this.userInputService.deleteValue('other_institutionName')
  }

  private clearHonoursAndPassScoreFields (): void {
    const honoursControl = this.academicDetailsForm.get('isHonoursDegree')
    honoursControl?.setValue('')
    honoursControl?.markAsUntouched()
    honoursControl?.markAsPristine()
    this.userInputService.deleteValue('isHonoursDegree')

    this.showApplicableGrade.set(false)
    this.clearApplicableGradeField()

    // Clear backlogs/retakes fields
    const backlogsControl = this.academicDetailsForm.get('numberOfBacklogsOrRetakes')
    backlogsControl?.clearValidators()
    backlogsControl?.setValue('')
    backlogsControl?.markAsUntouched()
    backlogsControl?.updateValueAndValidity()
    this.userInputService.deleteValue('numberOfBacklogsOrRetakes')

    const backlogsLast2YearsControl = this.academicDetailsForm.get('numberOfBacklogsRetakesInLast2Years')
    backlogsLast2YearsControl?.clearValidators()
    backlogsLast2YearsControl?.setValue('')
    backlogsLast2YearsControl?.markAsUntouched()
    backlogsLast2YearsControl?.updateValueAndValidity()
    this.userInputService.deleteValue('numberOfBacklogsRetakesInLast2Years')
  }

  private restoreApplicableGradeValidator (): void {
    // Restore pass score visibility based on current grade type
    const gradeTypeValue = this.academicDetailsForm.get('gradeType')?.value
    if (gradeTypeValue && this.allOptions['gradeType']) {
      const selectedGradeType = this.allOptions['gradeType'].find(
        (option: any) => option.option_label === gradeTypeValue
      )
      if (selectedGradeType?.option_value) {
        this.updateApplicableGradeVisibility(selectedGradeType.option_value)
      }
    }
  }

  private restoreBacklogsValidators (): void {
    // Only restore validators for India + non-UG
    if (this.selectedStudyCountryCode !== 'IND' || this.isUgQualification) return

    const backlogsQ = this.questions?.find((q: any) => q.mappingField === 'numberOfBacklogsOrRetakes')
    if (backlogsQ) {
      this.academicDetailsForm.get('numberOfBacklogsOrRetakes')?.setValidators(this.getBacklogsValidators(backlogsQ))
      this.academicDetailsForm.get('numberOfBacklogsOrRetakes')?.updateValueAndValidity()
    }

    const backlogsLast2Q = this.questions?.find((q: any) => q.mappingField === 'numberOfBacklogsRetakesInLast2Years')
    if (backlogsLast2Q) {
      this.academicDetailsForm.get('numberOfBacklogsRetakesInLast2Years')?.setValidators(this.getBacklogsValidators(backlogsLast2Q))
      this.academicDetailsForm.get('numberOfBacklogsRetakesInLast2Years')?.updateValueAndValidity()
    }
  }

  private getBacklogsValidators (question: any): any[] {
    const validators: any[] = []
    if (question?.mandatory) {
      validators.push(Validators.required)
    }
    // Parse min/max from options (option_desc: min_value/max_value)
    if (question?.options?.length) {
      const minOpt = question.options.find((o: any) => o.option_desc === 'min_value')
      const maxOpt = question.options.find((o: any) => o.option_desc === 'max_value')
      if (minOpt?.option_value !== undefined) {
        validators.push(Validators.min(Number(minOpt.option_value)))
      }
      if (maxOpt?.option_value !== undefined) {
        validators.push(Validators.max(Number(maxOpt.option_value)))
      }
    }
    // No decimals allowed — integers only
    validators.push(Validators.pattern(/^\d*$/))
    return validators
  }

  private clearSelectionWithCache (field: string, storageKey: string, dependents: string[]): void {
    const countryValue = this.getCountryCode()
    const qualValue = this.getQualificationId()
    const examBoardId = this.getExamBoardId()
    const gradeId = this.getGradeId()
    const payload: any = { country_3_code: countryValue, country_qual_id: qualValue }
    if (field === 'examBoardName' && countryValue && qualValue && examBoardId) {
      payload.qual_exam_board_id = examBoardId
      this.wirService.clearAcademicOptionsByPayload(payload)
    } else if (field === 'gradeType' && countryValue && qualValue && examBoardId && gradeId) {
      payload.qual_exam_board_id = examBoardId
      payload.grade_id = gradeId
      this.wirService.clearAcademicOptionsByPayload(payload)
    } else if (field === 'qualificationType' && countryValue && qualValue) {
      this.wirService.clearAcademicOptionsByPayload(payload)
    }
    this.resetFormField(field, storageKey)
    this.clearDependentFields(dependents)
  }

  private clearSelectionTest (field: string, storageKey: string, fieldsToClean: string[]): void {
    this.resetFormField(field, storageKey)
    this.showTestDate.set(false)
    this.showOverallScore.set(false)
    this.formFieldHelper.clearFieldsWithValidators(this.academicDetailsForm, fieldsToClean, 'academic')
  }

  clearSelection (field: string): void {
    const storageKey = this.getStorageKey(field)
    const handlers: { [key: string]: () => void } = {
      studyCountryName: () => this.clearSelectionCountry(field, storageKey),
      institutionName: () => this.clearSelectionInstitution(field, storageKey),
      qualificationType: () => this.clearSelectionQualification(field, storageKey),
      examBoardName: () => this.clearSelectionWithCache(field, storageKey, ['gradeType', 'finalGrade']),
      gradeType: () => { this.clearSelectionWithCache(field, storageKey, ['finalGrade']); this.showApplicableGrade.set(false); this.clearApplicableGradeField() },
      testType: () => this.clearSelectionTest(field, storageKey, ['testTakenDate', 'overallScore'])
    }
    const handler = handlers[field]
    if (handler) {
      handler()
    } else {
      this.resetFormField(field, storageKey)
    }
    if (field === 'studyEndDate') {
      this.endDateBeforeStartDate = false
      this.invalidEndDate = false
    }
    if (field === 'studyStartDate') {
      this.startDateAfterEndDate = false
      this.invalidStartDate = false
      this.futureStartDate = false
    }
  }

  initSearchFilter (field: string, options: any[]): void {
    this.allOptions[field] = options
    this.filteredOptions[field] = new ReplaySubject<any[]>(1)
    this.filteredOptions[field].next(options.slice())
    this.searchFilters[field] = new FormControl()
    this.searchFilters[field].valueChanges.subscribe(() => {
      this.filterOptions(field)
    })
  }

  filterOptions (field: string): void {
    let search = this.searchFilters[field].value

    if (!search) {
      this.filteredOptions[field].next(this.allOptions[field].slice())
      return
    }

    search = search.toLowerCase()
    const filtered = this.allOptions[field].filter((opt: any) =>
      opt.option_label.toLowerCase().includes(search)
    )

    this.filteredOptions[field].next(filtered)
  }

  getProgressiveProfileQstns (): any {
    const academicCpCallDone = this.userInputService.getValue('academic_cp_call_done')
    if (academicCpCallDone !== 'true') {
      this.userInputService.setValue('academic_cp_call_done', 'true')
      this.prePopulateFromCP()
    }

    this.questions = this.ProgressiveProfileQuestionsService.serviceQuestions?.items[0]?.fields?.questions
    if (this.questions === undefined) {
      this.showLoader.set(true)
      this.ProgressiveProfileQuestionsService.getPPqstns().subscribe(
        (res: any) => {
          this.questions = res.items[0].fields.questions
          this.extractQuestionLabels()
          this.generateFormControl(this.questions)
          this.showLoader.set(false)
        },
        (error: any) => {
          console.log(error)
          this.showLoader.set(false)
          this.route?.navigateByUrl('/error')
        }
      )
    } else {
      this.extractQuestionLabels()
      this.generateFormControl(this.questions)
    }
  }

  prePopulateFromCP (): void {
    const cpResponse = this.userInputService.getValue('cp_response')
    if (!cpResponse?.qualification_details?.educationHistory) return

    const eduHistory = cpResponse.qualification_details.educationHistory
    if (this.isExistingUser && eduHistory.studyCountryCode) {
      this.isRefDataLoading = true
    }
    this.prePopulateEducationHistory(eduHistory)
    this.prePopulateAdmissionTest(cpResponse.qualification_details.admissionTest)
  }

  private prePopulateEducationHistory (eduHistory: any): void {
    if (eduHistory.studyCountryCode) {
      this.userInputService.setValue('studyCountryName', { option_label: eduHistory.studyCountryName, option_value: eduHistory.studyCountryCode })
      this.fetchCountryValuesForPrePopulation(eduHistory)
    }

    const dateFields: Array<{ key: string, value: any }> = [
      { key: 'qualificationTitle', value: eduHistory.qualificationTitle },
      { key: 'studyStartDate', value: eduHistory.studyStartDate ? moment(eduHistory.studyStartDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : null },
      { key: 'studyEndDate', value: eduHistory.studyEndDate ? moment(eduHistory.studyEndDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : null }
    ]
    dateFields.forEach(f => {
      if (f.value) {
        const val = f.key === 'qualificationTitle' ? f.value : { option_value: f.value, option_label: f.value }
        this.userInputService.setValue(f.key, val)
      }
    })

    if (eduHistory.studyDuration != null) {
      this.userInputService.setValue('studyDuration', { option_value: eduHistory.studyDuration.toString(), option_label: eduHistory.studyDuration.toString() })
    }

    const pairedFields: Array<{ key: string, label: string, value: string }> = [
      { key: 'studyStatus', label: eduHistory.studyStatus, value: eduHistory.studyStatusId },
      { key: 'studyMode', label: eduHistory.studyMode, value: eduHistory.studyModeId },
      { key: 'studyLanguageName', label: eduHistory.studyLanguageName, value: eduHistory.studyLanguageCode }
    ]
    pairedFields.forEach(f => {
      if (f.label && f.value) {
        this.userInputService.setValue(f.key, { option_label: f.label, option_value: f.value })
      }
    })

    this.prePopulateMajorSubjects(eduHistory)

    // Prepopulate isHonoursDegree and applicableGrade
    if (eduHistory.isHonoursDegree !== undefined && eduHistory.isHonoursDegree !== null) {
      this.userInputService.setValue('isHonoursDegree', eduHistory.isHonoursDegree === true || eduHistory.isHonoursDegree === 'true')
    }
    if (eduHistory.institutionOverallPassGrade) {
      this.userInputService.setValue('applicableGrade', { option_label: eduHistory.institutionOverallPassGrade.toString(), option_value: eduHistory.institutionOverallPassGrade.toString() })
    }
    // Prepopulate backlogs/retakes fields
    if (eduHistory.failedSubjectsCount !== undefined && eduHistory.failedSubjectsCount !== null) {
      this.userInputService.setValue('numberOfBacklogsOrRetakes', { option_value: eduHistory.failedSubjectsCount.toString(), option_label: eduHistory.failedSubjectsCount.toString() })
    }
    if (eduHistory.failedSubjectsLast2YearCount !== undefined && eduHistory.failedSubjectsLast2YearCount !== null) {
      this.userInputService.setValue('numberOfBacklogsRetakesInLast2Years', { option_value: eduHistory.failedSubjectsLast2YearCount.toString(), option_label: eduHistory.failedSubjectsLast2YearCount.toString() })
    }
  }

  private prePopulateMajorSubjects (eduHistory: any): void {
    if (!eduHistory.majorSubjects || !eduHistory.majorSubjectIds) return
    try {
      const subjectsStr = eduHistory.majorSubjects.replace(/&#39;/g, "'")
      const subjectIdsStr = eduHistory.majorSubjectIds.replace(/&#39;/g, "'")
      const subjects = JSON.parse(subjectsStr.replace(/'/g, '"'))
      const subjectIds = JSON.parse(subjectIdsStr.replace(/'/g, '"'))
      if (subjects.length > 0 && subjectIds.length > 0) {
        this.userInputService.setValue('majorSubjects', [{ option_label: subjects[0], option_value: subjectIds[0] }])
      }
    } catch (e) {
      console.error('Error parsing majorSubjects', e)
    }
  }

  private prePopulateAdmissionTest (admissionTest: any): void {
    if (!admissionTest || Object.keys(admissionTest).length === 0) return
    if (admissionTest.testType && admissionTest.testTypeId) {
      this.userInputService.setValue('academic_testType', { option_label: admissionTest.testType, option_value: admissionTest.testTypeId })
    }
    if (admissionTest.testTakenDate) {
      const formattedDate = moment(admissionTest.testTakenDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
      this.userInputService.setValue('academic_testTakenDate', { option_value: formattedDate, option_label: formattedDate })
    }
    if (admissionTest.overallScore) {
      this.userInputService.setValue('academic_overallScore', { option_value: admissionTest.overallScore.toString(), option_label: admissionTest.overallScore.toString() })
    }
  }

  fetchCountryValuesForPrePopulation (eduHistory: any): void {
    this.selectedStudyCountryCode = eduHistory.studyCountryCode || ''
    const payload = { country_3_code: eduHistory.studyCountryCode }
    this.wirService.getReferencedValues(payload).subscribe(
      (res: any) => {
        if (res?.data) {
          this.updateCountryOptions(res.data)
          this.showQualificationType.set(true)
          setTimeout(() => {
            const hasQualification = this.prePopulateFromCountryResponse(eduHistory, res.data)
            if (!hasQualification) {
              this.isRefDataLoading = false
            }
          }, 100)
        } else {
          this.isRefDataLoading = false
        }
      },
      (error: any) => {
        console.error('Error fetching country values:', error)
        this.isRefDataLoading = false
      }
    )
  }

  private prePopulateFromCountryResponse (eduHistory: any, data: any): boolean {
    let selectedQualIsUg = false
    this.prePopulateInstitutionFromCP(eduHistory, data)
    selectedQualIsUg = this.prePopulateQualificationFromCP(eduHistory, data)
    this.showInstitution.set(!selectedQualIsUg)
    this.showHonoursAndPassScore.set(!selectedQualIsUg && this.HONOURS_ELIGIBLE_COUNTRIES.includes(this.selectedStudyCountryCode))
    this.showMajorSubjects.set(!selectedQualIsUg)
    return !!eduHistory.qualificationType && data.qualifications?.some(
      (qual: any) => qual.country_qual_type_alias === eduHistory.qualificationType ||
        qual.country_qual_id === eduHistory.qualificationTypeId ||
        qual.qual_id === eduHistory.qualificationTypeId
    )
  }

  private prePopulateInstitutionFromCP (eduHistory: any, data: any): void {
    if (eduHistory.institutionId === '0' || eduHistory.institutionId === 0) {
      this.userInputService.setValue('institutionName', { option_label: 'Others', option_value: '0' })
      this.academicDetailsForm.patchValue({ institutionName: 'Others' })
      this.showOtherInstitution.set(true)
      this.userInputService.setValue('other_institutionName', eduHistory.institutionName)
      this.academicDetailsForm.patchValue({ other_institutionName: eduHistory.institutionName })
      const institutionQuestion = this.questions?.find((q: any) => q.mappingField === 'institutionName' && q.displayFormat.value === 'TEXT_BOX')
      if (institutionQuestion?.mandatory) {
        this.academicDetailsForm.get('other_institutionName')?.setValidators([Validators.required])
        this.academicDetailsForm.get('other_institutionName')?.updateValueAndValidity()
      }
      return
    }
    if (!eduHistory.institutionName) return
    const matchedInstitution = data.institutions?.find(
      (inst: any) => inst.institution_name === eduHistory.institutionName || inst.institution_id === eduHistory.institutionId
    )
    if (matchedInstitution) {
      this.userInputService.setValue('institutionName', { option_label: matchedInstitution.institution_name, option_value: matchedInstitution.institution_id })
      this.academicDetailsForm.patchValue({ institutionName: matchedInstitution.institution_name })
    }
  }

  private prePopulateQualificationFromCP (eduHistory: any, data: any): boolean {
    if (!eduHistory.qualificationType) return false
    const matchedQualification = data.qualifications?.find(
      (qual: any) => qual.country_qual_type_alias === eduHistory.qualificationType ||
        qual.country_qual_id === eduHistory.qualificationTypeId ||
        qual.qual_id === eduHistory.qualificationTypeId
    )
    if (!matchedQualification) return false
    const isUg = matchedQualification.study_level_id === '1'
    this.isUgQualification = isUg
    this.isPgQualification = matchedQualification.study_level_id === '2'
    this.userInputService.setValue('qualificationType', {
      option_label: matchedQualification.country_qual_type_alias,
      option_value: matchedQualification.qual_id,
      country_qual_id: matchedQualification.country_qual_id,
      study_level_id: matchedQualification.study_level_id
    })
    this.academicDetailsForm.patchValue({ qualificationType: matchedQualification.country_qual_type_alias })
    if (matchedQualification.country_qual_id) {
      this.fetchExamBoardsForPrePopulation(eduHistory, matchedQualification.country_qual_id)
    }
    return isUg
  }

  fetchExamBoardsForPrePopulation (eduHistory: any, countryQualId: string): void {
    const payload = {
      country_3_code: eduHistory.studyCountryCode,
      country_qual_id: countryQualId
    }
    this.wirService.getReferencedValues(payload).subscribe(
      (res: any) => {
        if (res?.data?.qual_exam_boards) {
          if (res.data.qual_exam_boards.length > 0) {
            this.updateExamBoardOptions(res.data.qual_exam_boards)
            this.showExamBoard.set(true)
            const examBoardQuestion = this.questions?.find((q: any) => q.mappingField === 'examBoardName')
            if (examBoardQuestion?.mandatory) {
              this.academicDetailsForm.get('examBoardName')?.setValidators([Validators.required])
            }
            this.academicDetailsForm.get('examBoardName')?.updateValueAndValidity()

            setTimeout(() => {
              if (eduHistory.examBoardName) {
                const matchedExamBoard = res.data.qual_exam_boards.find(
                  (board: any) => board.exam_board_name === eduHistory.examBoardName ||
                                 board.qual_exam_board_id === eduHistory.examBoardId
                )
                if (matchedExamBoard) {
                  this.userInputService.setValue('examBoardName', {
                    option_label: matchedExamBoard.exam_board_name,
                    option_value: matchedExamBoard.exam_board_id,
                    qual_exam_board_id: matchedExamBoard.qual_exam_board_id
                  })
                  this.academicDetailsForm.patchValue({ examBoardName: matchedExamBoard.exam_board_name })
                  this.fetchGradeTypesForPrePopulation(eduHistory, countryQualId, matchedExamBoard.qual_exam_board_id)
                } else {
                  this.fetchGradeTypesForPrePopulation(eduHistory, countryQualId, 'GLO')
                }
              } else {
                this.fetchGradeTypesForPrePopulation(eduHistory, countryQualId, 'GLO')
              }
            }, 100)
          } else {
            this.showExamBoard.set(false)
            this.academicDetailsForm.get('examBoardName')?.clearValidators()
            this.academicDetailsForm.get('examBoardName')?.updateValueAndValidity()
            this.fetchGradeTypesForPrePopulation(eduHistory, countryQualId, 'GLO')
          }
        } else {
          this.isRefDataLoading = false
        }
      },
      (error: any) => {
        console.error('Error fetching exam boards:', error)
        this.isRefDataLoading = false
      }
    )
  }

  fetchGradeTypesForPrePopulation (eduHistory: any, countryQualId: string, examBoardId: string): void {
    const payload = {
      country_3_code: eduHistory.studyCountryCode,
      country_qual_id: countryQualId,
      qual_exam_board_id: examBoardId
    }
    this.wirService.getReferencedValues(payload).subscribe(
      (res: any) => {
        if (res?.data) {
          this.updateGradeTypeOptions(res.data)
          this.showGradeType.set(true)

          setTimeout(() => {
            if (eduHistory.gradeType) {
              const matchedGradeType = res.data.qual_exam_board_grades?.find(
                (grade: any) => grade.grade_type_name === eduHistory.gradeType ||
                               grade.grade_id === eduHistory.gradeTypeId
              )
              if (matchedGradeType) {
                this.userInputService.setValue('gradeType', {
                  option_label: matchedGradeType.grade_type_name,
                  option_value: matchedGradeType.grade_type_code,
                  qual_exam_board_grade_id: matchedGradeType.qual_exam_board_grade_id,
                  grade_id: matchedGradeType.grade_id
                })
                this.academicDetailsForm.patchValue({ gradeType: matchedGradeType.grade_type_name })
                this.updateApplicableGradeVisibility(matchedGradeType.grade_type_code)
                // Restore applicableGrade form value from UserInputService if prepopulated
                setTimeout(() => {
                  const storedApplicableGrade = this.userInputService.getValue('applicableGrade')
                  if (storedApplicableGrade && this.showApplicableGrade()) {
                    const patchVal = typeof storedApplicableGrade === 'string' ? storedApplicableGrade : storedApplicableGrade?.option_label
                    if (patchVal) {
                      this.academicDetailsForm.patchValue({ applicableGrade: patchVal })
                    }
                  }
                })
                this.fetchGradeDetailsForPrePopulation(eduHistory, countryQualId, examBoardId, matchedGradeType.grade_id)
              } else {
                this.isRefDataLoading = false
              }
            } else {
              this.isRefDataLoading = false
            }
          }, 100)
        } else {
          this.isRefDataLoading = false
        }
      },
      (error: any) => {
        console.error('Error fetching grade types:', error)
        this.isRefDataLoading = false
      }
    )
  }

  fetchGradeDetailsForPrePopulation (eduHistory: any, countryQualId: string, examBoardId: string, gradeId: string): void {
    const payload = {
      country_3_code: eduHistory.studyCountryCode,
      country_qual_id: countryQualId,
      qual_exam_board_id: examBoardId,
      grade_id: gradeId
    }
    this.wirService.getReferencedValues(payload).subscribe(
      (res: any) => {
        if (res?.data?.qual_exam_board_grades_values) {
          this.handleGradeValuesResponse(res.data.qual_exam_board_grades_values)
          this.showFinalGrade.set(true)

          setTimeout(() => {
            if (eduHistory.finalGrade) {
              if (this.gradeInputType === 'input') {
                const gradeValueId = this.gradeInputConfig?.grade_value_id || null
                this.userInputService.setValue('finalGrade', { option_value: eduHistory.finalGrade, option_label: eduHistory.finalGrade, grade_value_id: gradeValueId })
                this.academicDetailsForm.patchValue({ finalGrade: eduHistory.finalGrade })
              } else if (this.gradeInputType === 'dropdown') {
                const matchedGrade = res.data.qual_exam_board_grades_values.find(
                  (grade: any) => grade.grade_val === eduHistory.finalGrade
                )
                if (matchedGrade) {
                  this.userInputService.setValue('finalGrade', {
                    option_label: matchedGrade.grade_val,
                    option_value: matchedGrade.grade_value_id,
                    qual_exam_board_grade_id: matchedGrade.qual_exam_board_grade_id,
                    rank: matchedGrade.rank ?? null
                  })
                  this.academicDetailsForm.patchValue({ finalGrade: matchedGrade.grade_val })
                }
              }
            }
            this.isRefDataLoading = false
          }, 100)
        } else {
          this.isRefDataLoading = false
        }
      },
      (error: any) => {
        console.error('Error fetching grade details:', error)
        this.isRefDataLoading = false
      }
    )
  }

  getFieldValidators (ppQuestion: any): any[] {
    return ppQuestion.mandatory ? [Validators.required] : []
  }

  isFirstApplicableGradeQuestion (question: any): boolean {
    const first = this.questions?.find((q: any) => q.mappingField === 'applicableGrade')
    return first === question
  }

  hasHonoursQuestion (): boolean {
    return this.questions?.some((q: any) => q.mappingField === 'isHonoursDegree') || false
  }

  getHonoursQuestion (): any {
    return this.questions?.find((q: any) => q.mappingField === 'isHonoursDegree')
  }

  getBacklogsQuestion (): any {
    return this.questions?.find((q: any) => q.mappingField === 'numberOfBacklogsOrRetakes')
  }

  getBacklogsLast2YearsQuestion (): any {
    return this.questions?.find((q: any) => q.mappingField === 'numberOfBacklogsRetakesInLast2Years')
  }

  getBacklogsMin (question: any): number {
    const minOpt = question?.options?.find((o: any) => o.option_desc === 'min_value')
    return minOpt ? Number(minOpt.option_value) : 0
  }

  getBacklogsMax (question: any): number {
    const maxOpt = question?.options?.find((o: any) => o.option_desc === 'max_value')
    return maxOpt ? Number(maxOpt.option_value) : 999
  }

  hasApplicableGradeQuestion (): boolean {
    return this.questions?.some((q: any) => q.mappingField === 'applicableGrade') || false
  }

  getFirstApplicableGradeQuestion (): any {
    return this.questions?.find((q: any) => q.mappingField === 'applicableGrade')
  }

  private extractQuestionLabels (): void {
    if (!this.questions) return
    const applicableGradeQ = this.questions.find((q: any) => q.mappingField === 'applicableGrade')
    this.applicableGradeQuestion = applicableGradeQ || null
    if (applicableGradeQ?.label) {
      this.applicableGradeLabel = applicableGradeQ.label
    }
    if (applicableGradeQ?.helpText) {
      this.applicableGradeHelpText = applicableGradeQ.helpText
    }
    if (applicableGradeQ) {
      this.applicableGradeMandatory = applicableGradeQ.mandatory === true
    }
    const honoursQ = this.questions.find((q: any) => q.mappingField === 'isHonoursDegree')
    this.honoursQuestion = honoursQ || null
    if (honoursQ?.label) {
      this.honoursDegreeText = honoursQ.label
    }
    if (honoursQ?.helpText) {
      this.honoursDegreeHelpText = honoursQ.helpText
    }
    if (honoursQ) {
      this.honoursDegreeMandatory = honoursQ.mandatory === true
    }
    if (honoursQ?.options?.length >= 2) {
      this.yesText = honoursQ.options.find((o: any) => o.option_value === '1')?.option_label || this.yesText || 'Yes'
      this.noText = honoursQ.options.find((o: any) => o.option_value === '2')?.option_label || this.noText || 'No'
    }
  }

  generateFormControl (ppQuestions: any): any {
    const formControl: any = {}
    if (ppQuestions) {
      ppQuestions.forEach((element: any) => {
        this.processFormElement(element, formControl)
      })
    }
    this.createFormGroup(formControl)
  }

  processFormElement (element: any, formControl: any): void {
    this.addFormControlByType(element, formControl)
    this.initializeSearchFilterIfNeeded(element)
  }

  addFormControlByType (element: any, formControl: any): void {
    const displayFormat = element.displayFormat?.value

    if (displayFormat === 'SELECT_BOX') {
      this.addSelectBoxControl(element, formControl)
    } else if (displayFormat === 'TEXT_BOX' || displayFormat === 'RANGE') {
      this.addTextBoxControl(element, formControl)
    } else if (displayFormat === 'DATE_PICKER') {
      this.addDatePickerControl(element, formControl)
    }
  }

  private readonly ADMISSION_TEST_DEPENDENT_FIELDS = ['testType', 'testTakenDate', 'overallScore']

  private getFieldValidatorsForElement (element: any): any[] {
    if (this.ADMISSION_TEST_DEPENDENT_FIELDS.includes(element.mappingField)) {
      return []
    }
    return this.getFieldValidators(element)
  }

  addSelectBoxControl (element: any, formControl: any): void {
    const selectBoxFields = ['studyCountryName', 'institutionName', 'qualificationType', 'examBoardName', 'majorSubjects', 'studyMode', 'studyStatus', 'gradeType', 'finalGrade', 'studyLanguageName', 'applicableGrade']

    if (selectBoxFields.includes(element.mappingField) || (element.mappingField === 'testType' && element.questionAttributeId === 2326)) {
      if (!formControl[element.mappingField]) {
        formControl[element.mappingField] = new FormControl('', this.getFieldValidatorsForElement(element))
      }
    }
  }

  addTextBoxControl (element: any, formControl: any): void {
    const textBoxFields = ['qualificationTitle', 'studyDuration', 'finalGrade', 'numberOfBacklogsOrRetakes', 'numberOfBacklogsRetakesInLast2Years']

    if (textBoxFields.includes(element.mappingField) || (element.mappingField === 'overallScore' && element.questionAttributeId === 2336)) {
      const validators = this.getFieldValidatorsForElement(element)
      if (element.mappingField === 'studyDuration') {
        validators.push(Validators.pattern(/^\d+(\.\d)?$/))
      }
      formControl[element.mappingField] = new FormControl('', validators)
    }

    if (element.mappingField === 'institutionName' && element.displayFormat.value === 'TEXT_BOX') {
      formControl.other_institutionName = new FormControl('', this.getFieldValidatorsForElement(element))
    }
  }

  addDatePickerControl (element: any, formControl: any): void {
    const datePickerFields = ['studyStartDate', 'studyEndDate']

    if (datePickerFields.includes(element.mappingField) || (element.mappingField === 'testTakenDate' && element.questionAttributeId === 2337)) {
      formControl[element.mappingField] = new FormControl('', this.getFieldValidatorsForElement(element))
    }
  }

  initializeSearchFilterIfNeeded (element: any): void {
    const searchFilterFields = ['studyLanguageName', 'studyCountryName', 'majorSubjects', 'institutionName', 'qualificationType', 'examBoardName', 'gradeType']
    if (searchFilterFields.includes(element.mappingField) || (element.mappingField === 'finalGrade' && element.displayFormat.value === 'SELECT_BOX') || (element.mappingField === 'applicableGrade' && element.displayFormat.value === 'SELECT_BOX')) {
      this.initSearchFilter(element.mappingField, element.options ?? [])
    }
  }

  createFormGroup (formControl: any): void {
    // Ensure isHonoursDegree and applicableGrade controls always exist
    if (!formControl.isHonoursDegree) {
      const honoursQ = this.questions?.find((q: any) => q.mappingField === 'isHonoursDegree')
      formControl.isHonoursDegree = new FormControl('', honoursQ?.mandatory ? [Validators.required] : [])
    }
    if (!formControl.applicableGrade) {
      const applicableGradeQ = this.questions?.find((q: any) => q.mappingField === 'applicableGrade')
      formControl.applicableGrade = new FormControl('', applicableGradeQ?.mandatory ? [Validators.required] : [])
    }
    // Ensure backlogs controls always exist with min/max/integer validators from PP
    if (!formControl.numberOfBacklogsOrRetakes) {
      const backlogsQ = this.questions?.find((q: any) => q.mappingField === 'numberOfBacklogsOrRetakes')
      const backlogsValidators = this.getBacklogsValidators(backlogsQ)
      formControl.numberOfBacklogsOrRetakes = new FormControl('', backlogsValidators)
    }
    if (!formControl.numberOfBacklogsRetakesInLast2Years) {
      const backlogsLast2Q = this.questions?.find((q: any) => q.mappingField === 'numberOfBacklogsRetakesInLast2Years')
      const backlogsLast2Validators = this.getBacklogsValidators(backlogsLast2Q)
      formControl.numberOfBacklogsRetakesInLast2Years = new FormControl('', backlogsLast2Validators)
    }
    this.academicDetailsForm = new FormGroup(formControl)
    this.restoreFormValues()
    this.restoreConditionalFields()
    this.academicDetailsForm.updateValueAndValidity()
    this.showLoader.set(false)
  }

  restoreFormValues (): void {
    const storedData = this.userInputService.getAllValues()
    const patchValues: { [key: string]: any } = {}

    for (const key in storedData) {
      const value = storedData[key]
      if (this.shouldSkipKey(key)) {
        continue
      }

      const fieldName = this.getFieldName(key)
      patchValues[fieldName] = this.formatFieldValue(fieldName, key, value)
    }

    this.academicDetailsForm.patchValue(patchValues)
    this.checkOtherInstitution()
  }

  shouldSkipKey (key: string): boolean {
    return key.startsWith('english_') || key === 'other_institutionName'
  }

  getFieldName (key: string): string {
    return key.startsWith('academic_') ? key.replace('academic_', '') : key
  }

  formatFieldValue (fieldName: string, key: string, value: any): any {
    const dateFields = ['studyStartDate', 'studyEndDate', 'testTakenDate']
    if (dateFields.includes(fieldName)) {
      const dateValue = typeof value === 'string' ? value : value?.option_value
      return moment(dateValue, 'DD/MM/YYYY')
    }

    if (fieldName === 'status') {
      return typeof value === 'string' ? value : value?.option_value
    }

    if (fieldName === 'majorSubjects') {
      if (Array.isArray(value) && value.length > 0) {
        return value[0]?.option_label || value[0] || value
      }
      return typeof value === 'string' ? value : value?.option_label
    }

    // For chip fields (studyMode, studyStatus), match by option_value or option_label to get localized label
    if (fieldName === 'studyMode' || fieldName === 'studyStatus') {
      const question = this.questions?.find((q: any) => q.mappingField === fieldName)
      if (question?.options?.length) {
        const matchedOpt = question.options.find((opt: any) =>
          (value?.option_value && (opt.option_value === value.option_value || opt.option_label === value.option_value)) ||
          (value?.option_label && (opt.option_value === value.option_label || opt.option_label === value.option_label))
        )
        if (matchedOpt) {
          this.userInputService.setValue(key, matchedOpt)
          return matchedOpt.option_label
        }
      }
    }

    if (fieldName === 'isHonoursDegree') {
      const isYes = value === true || value === 'true'
      const isNo = value === false || value === 'false'
      if (typeof value === 'boolean' || isYes || isNo) {
        // Look up translated option_label from PP questions
        const honoursQ = this.questions?.find((q: any) => q.mappingField === 'isHonoursDegree')
        if (honoursQ?.options?.length) {
          const targetValue = (typeof value === 'boolean' ? value : isYes) ? '1' : '2'
          const matchedOpt = honoursQ.options.find((o: any) => o.option_value === targetValue)
          if (matchedOpt) return matchedOpt.option_label
        }
        // Fallback to English
        return (typeof value === 'boolean' ? value : isYes) ? 'Yes' : 'No'
      }
      return ''
    }

    if (fieldName === 'applicableGrade') {
      return typeof value === 'string' ? value : value?.option_label || ''
    }

    return typeof value === 'string' ? value : value?.option_label
  }

  checkOtherInstitution (): void {
    const institutionValue = this.academicDetailsForm.get('institutionName')?.value
    if (institutionValue && typeof institutionValue === 'string' && institutionValue.toLowerCase() === 'others') {
      this.showOtherInstitution.set(true)
      const otherInstitutionValue = this.userInputService.getValue('other_institutionName')
      const otherInstitutionString = typeof otherInstitutionValue === 'string' ? otherInstitutionValue : (otherInstitutionValue?.option_value || otherInstitutionValue?.option_label || '')
      if (otherInstitutionString) {
        this.academicDetailsForm.patchValue({ other_institutionName: otherInstitutionString }, { emitEvent: false })
      }
      const institutionQuestion = this.questions?.find((q: any) => q.mappingField === 'institutionName' && q.displayFormat.value === 'TEXT_BOX')
      if (institutionQuestion?.mandatory) {
        const othersControl = this.academicDetailsForm.get('other_institutionName')
        othersControl?.setValidators([Validators.required])
        othersControl?.updateValueAndValidity()
      }
    }
  }

  restoreConditionalFields (): void {
    const countryCode = this.getCountryCode()
    if (!countryCode) {
      return
    }

    this.restoreCountryDependentFields(countryCode)
    this.restoreTestConfig()
  }

  restoreCountryDependentFields (countryCode: string): void {
    const cachedData = this.wirService.getStoredAcademicOptions({ country_3_code: countryCode })
    if (cachedData?.data) {
      this.updateCountryOptions(cachedData.data)
      this.showQualificationType.set(true)
      this.selectedStudyCountryCode = countryCode

      const qualValue = this.academicDetailsForm.get('qualificationType')?.value
      const selectedQual = this.allOptions['qualificationType']?.find(
        (option: any) => option.option_label === qualValue
      )

      this.isUgQualification = selectedQual?.study_level_id === '1'
      this.isPgQualification = selectedQual?.study_level_id === '2'

      if (selectedQual && !this.isUgQualification) {
        this.showInstitution.set(true)
        this.showMajorSubjects.set(true)
        this.showHonoursAndPassScore.set(!this.isUgQualification && this.HONOURS_ELIGIBLE_COUNTRIES.includes(this.selectedStudyCountryCode))
        this.restoreValidatorIfMandatory('institutionName', 'SELECT_BOX')
        this.restoreValidatorIfMandatory('majorSubjects')
        this.restoreApplicableGradeValidator()
        this.restoreBacklogsValidators()
      } else {
        this.showInstitution.set(false)
        this.showMajorSubjects.set(false)
        this.showHonoursAndPassScore.set(false)
      }

      const qualId = this.getQualificationId()
      if (qualId) {
        this.restoreQualificationDependentFields(countryCode, qualId)
      }
    }
  }

  restoreQualificationDependentFields (countryCode: string, qualId: string): void {
    const cachedData = this.wirService.getStoredAcademicOptions({ country_3_code: countryCode, country_qual_id: qualId })
    if (!cachedData?.data?.qual_exam_boards) {
      return
    }

    this.showExamBoard.set(cachedData.data.qual_exam_boards.length > 0)
    if (this.showExamBoard()) {
      this.updateExamBoardOptions(cachedData.data.qual_exam_boards)
      const examBoardQuestion = this.questions?.find((q: any) => q.mappingField === 'examBoardName')
      if (examBoardQuestion?.mandatory) {
        this.academicDetailsForm.get('examBoardName')?.setValidators([Validators.required])
      }
      this.academicDetailsForm.get('examBoardName')?.updateValueAndValidity()
    } else {
      this.academicDetailsForm.get('examBoardName')?.clearValidators()
      this.academicDetailsForm.get('examBoardName')?.updateValueAndValidity()
    }

    const examBoardId = this.getExamBoardId() || 'GLO'
    this.restoreGradeTypeFields(countryCode, qualId, examBoardId)
  }

  restoreGradeTypeFields (countryCode: string, qualId: string, examBoardId: string): void {
    const cachedData = this.wirService.getStoredAcademicOptions({ country_3_code: countryCode, country_qual_id: qualId, qual_exam_board_id: examBoardId })
    if (!cachedData?.data) {
      return
    }

    this.updateGradeTypeOptions(cachedData.data)
    this.showGradeType.set(true)

    const gradeTypeValue = this.academicDetailsForm.get('gradeType')?.value
    if (gradeTypeValue) {
      // Restore applicable grade visibility based on grade_type_code
      const selectedGradeType = this.allOptions['gradeType']?.find(
        (option: any) => option.option_label === gradeTypeValue
      )
      if (selectedGradeType?.option_value) {
        this.updateApplicableGradeVisibility(selectedGradeType.option_value)
        // Restore applicableGrade form value
        setTimeout(() => {
          const storedApplicableGrade = this.userInputService.getValue('applicableGrade')
          if (storedApplicableGrade && this.showApplicableGrade()) {
            const patchVal = typeof storedApplicableGrade === 'string' ? storedApplicableGrade : storedApplicableGrade?.option_label
            if (patchVal) {
              this.academicDetailsForm.patchValue({ applicableGrade: patchVal })
            }
          }
        })
      }
      this.restoreFinalGradeField(countryCode, qualId, examBoardId, gradeTypeValue)
    }
  }

  restoreFinalGradeField (countryCode: string, qualId: string, examBoardId: string, gradeTypeValue: string): void {
    const gradeId = this.getGradeIdFromValue(gradeTypeValue)
    if (!gradeId) {
      return
    }

    const cachedData = this.wirService.getStoredAcademicOptions({ country_3_code: countryCode, country_qual_id: qualId, qual_exam_board_id: examBoardId, grade_id: gradeId })
    if (cachedData?.data?.qual_exam_board_grades_values) {
      this.handleGradeValuesResponse(cachedData.data.qual_exam_board_grades_values)
      // Re-store finalGrade value with grade_value_id for input-type grades
      if (this.gradeInputType === 'input' && this.gradeInputConfig?.grade_value_id) {
        const storedFinalGrade = this.userInputService.getValue('finalGrade')
        if (storedFinalGrade && !storedFinalGrade.grade_value_id) {
          const gradeVal = typeof storedFinalGrade === 'string' ? storedFinalGrade : (storedFinalGrade.option_label || storedFinalGrade.option_value)
          if (gradeVal) {
            this.userInputService.setValue('finalGrade', { option_value: gradeVal, option_label: gradeVal, grade_value_id: this.gradeInputConfig.grade_value_id })
          }
        }
      }
    }
  }

  restoreTestConfig (): void {
    const testType = this.academicDetailsForm.get('testType')?.value
    const storedTestType = this.userInputService.getValue('academic_testType')
    const isNotTaken = storedTestType?.option_value === 'tt_17' || testType?.toLowerCase() === 'not taken'
    if (testType && !isNotTaken) {
      this.showTestDate.set(true)
      this.showOverallScore.set(true)
      this.updateTestScoreConfig(testType)
    } else {
      this.showTestDate.set(false)
      this.showOverallScore.set(false)
      this.formFieldHelper.clearValidatorsAndUpdate(this.academicDetailsForm, ['testTakenDate', 'overallScore'])
    }
  }

  getGradeIdFromValue (gradeTypeValue: string): string | null {
    if (this.allOptions['gradeType']) {
      const selectedGradeType = this.allOptions['gradeType'].find(
        (option: any) => option.option_label === gradeTypeValue
      )
      if (selectedGradeType?.grade_id) {
        return selectedGradeType.grade_id
      }
    }

    const countryCode = this.getCountryCode()
    const qualId = this.getQualificationId()
    const examBoardId = this.getExamBoardId() || 'GLO'

    if (countryCode && qualId) {
      const payload = { country_3_code: countryCode, country_qual_id: qualId, qual_exam_board_id: examBoardId }
      const storedGradeTypeData = this.wirService.getStoredAcademicOptions(payload)
      if (storedGradeTypeData?.data?.qual_exam_board_grades) {
        const selectedGradeType = storedGradeTypeData.data.qual_exam_board_grades.find(
          (grade: any) => grade.grade_type_name === gradeTypeValue
        )
        return selectedGradeType?.grade_id || null
      }
    }

    return null
  }

  getGradeId (): string | null {
    const gradeTypeValue = this.academicDetailsForm.get('gradeType')?.value
    if (!gradeTypeValue) return null
    return this.getGradeIdFromValue(gradeTypeValue)
  }

  onDateChange (event: any, field: string): void {
    this.invalidStartDate = false
    this.invalidEndDate = false
    this.invalidTestDate = false
    this.futureStartDate = false
    this.futureTestDate = false
    this.startDateAfterEndDate = false
    this.endDateBeforeStartDate = false
    const storageKey = this.getStorageKey(field)
    const d = moment(event.value).format('DD/MM/YYYY')
    if (!(d.match(/^\d{2}\/\d{2}\/\d{4}$/) && d.includes('/'))) {
      this.userInputService.deleteValue(storageKey)
      if (field === 'studyStartDate') this.invalidStartDate = true
      if (field === 'studyEndDate') this.invalidEndDate = true
      if (field === 'testTakenDate') this.invalidTestDate = true
    } else {
      const selectedDate = moment(event.value)
      const todayDate = moment().startOf('day')
      const formattedDate = selectedDate.format('DD/MM/YYYY')

      if (field === 'studyStartDate' || field === 'testTakenDate') {
        if (selectedDate.isAfter(todayDate)) {
          this.userInputService.deleteValue(storageKey)
          if (field === 'studyStartDate') this.futureStartDate = true
          if (field === 'testTakenDate') this.futureTestDate = true
        } else if (field === 'studyStartDate') {
          const endDateValue = this.userInputService.getValue(this.getStorageKey('studyEndDate'))
          const endDateStr = endDateValue?.option_value || endDateValue?.option_label
          if (endDateStr) {
            const endDate = moment(endDateStr, 'DD/MM/YYYY')
            if (selectedDate.isAfter(endDate)) {
              this.startDateAfterEndDate = true
              this.userInputService.deleteValue(storageKey)
              return
            }
          }
          this.userInputService.setValue(storageKey, { option_value: formattedDate, option_label: formattedDate })
        } else {
          this.userInputService.setValue(storageKey, { option_value: formattedDate, option_label: formattedDate })
        }
      } else if (field === 'studyEndDate') {
        const startDateValue = this.userInputService.getValue(this.getStorageKey('studyStartDate'))
        const startDateStr = startDateValue?.option_value || startDateValue?.option_label
        if (startDateStr) {
          const startDate = moment(startDateStr, 'DD/MM/YYYY')
          if (selectedDate.isBefore(startDate)) {
            this.endDateBeforeStartDate = true
            this.userInputService.deleteValue(storageKey)
            return
          }
        }
        this.userInputService.setValue(storageKey, { option_value: formattedDate, option_label: formattedDate })
      }
    }
  }

  onInputString (field: string, event: FocusEvent): void {
    const inputElement = event.target as HTMLInputElement
    let trimmedValue = inputElement.value.trim()
    const storageKey = field === 'other_institutionName' ? 'other_institutionName' : this.getStorageKey(field)

    if (field === 'finalGrade' && this.gradeInputType === 'input' && trimmedValue !== '') {
      const numericValue = Number(trimmedValue)
      if (!isNaN(numericValue)) {
        trimmedValue = String(numericValue)
      }
    }

    inputElement.value = trimmedValue
    if (field === 'finalGrade' && this.gradeInputType === 'input' && this.gradeInputConfig?.grade_value_id) {
      this.userInputService.setValue(storageKey, { option_value: trimmedValue, option_label: trimmedValue, grade_value_id: this.gradeInputConfig.grade_value_id })
    } else {
      this.userInputService.setValue(storageKey, { option_value: trimmedValue, option_label: trimmedValue })
    }
    this.academicDetailsForm.get(field)?.setValue(trimmedValue)
  }

  preventEnter (event: Event): void {
    const keyboardEvent = event as KeyboardEvent
    keyboardEvent.preventDefault()
    keyboardEvent.stopPropagation()
  }

  nextButton (): void {
    this.submitted = true
    this.ensureHiddenFieldsHaveNoValidation()
    this.validateDateCrossFields()

    if (this.invalidStartDate || this.invalidEndDate || this.invalidTestDate || this.futureStartDate || this.futureTestDate || this.startDateAfterEndDate || this.endDateBeforeStartDate) {
      setTimeout(() => {
        const invalidControl = document.querySelector(
          'form .date-error'
        ) as HTMLElement

        if (invalidControl) {
          invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' })
          setTimeout(() => {
            const elementToFocus =
              invalidControl.querySelector('input, [type="checkbox"], mat-select') ||
              invalidControl
            elementToFocus.classList.add('scroll-field-error');
            (elementToFocus as HTMLElement).focus()
          }, 300)
        }
      })
      return
    }

    if (this.academicDetailsForm.valid) {
      this.gtmImplementation.trackEvents('wir_academic_details', 'next_button', 'next', 'academic_details', 'signed_in_user', 'user_registration')
      this.nextClicked.emit()
    } else {
      // Debug: log which controls are invalid
      const invalidControls: string[] = []
      Object.keys(this.academicDetailsForm.controls).forEach(key => {
        if (this.academicDetailsForm.get(key)?.invalid) {
          invalidControls.push(key)
        }
      })
      console.log('[AcademicDetails] Form invalid. Invalid controls:', invalidControls)
      setTimeout(() => {
        const invalidControl = document.querySelector(
          'form .ng-invalid:not(form)'
        ) as HTMLElement

        if (invalidControl) {
          invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' })
          setTimeout(() => {
            const elementToFocus =
              invalidControl.querySelector('input, [type="checkbox"], mat-select') ||
              invalidControl
            elementToFocus.classList.add('scroll-field-error');
            (elementToFocus as HTMLElement).focus()
          }, 300)
        }
      }, 50)
    }
  }

  validateDateCrossFields (): void {
    const startDateValue = this.userInputService.getValue(this.getStorageKey('studyStartDate'))
    const endDateValue = this.userInputService.getValue(this.getStorageKey('studyEndDate'))
    const startDateStr = startDateValue?.option_value || startDateValue?.option_label
    const endDateStr = endDateValue?.option_value || endDateValue?.option_label

    if (startDateStr && endDateStr) {
      const startDate = moment(startDateStr, 'DD/MM/YYYY')
      const endDate = moment(endDateStr, 'DD/MM/YYYY')
      if (endDate.isBefore(startDate)) {
        this.endDateBeforeStartDate = true
      }
      if (startDate.isAfter(endDate)) {
        this.startDateAfterEndDate = true
      }
    }

    // Also validate using form control values (date may exist in form but not in userInputService)
    if (!this.endDateBeforeStartDate && !this.startDateAfterEndDate) {
      const startFormValue = this.academicDetailsForm.get('studyStartDate')?.value
      const endFormValue = this.academicDetailsForm.get('studyEndDate')?.value
      if (startFormValue && endFormValue) {
        const startDate = moment(startFormValue)
        const endDate = moment(endFormValue)
        if (startDate.isValid() && endDate.isValid()) {
          if (endDate.isBefore(startDate)) {
            this.endDateBeforeStartDate = true
          }
          if (startDate.isAfter(endDate)) {
            this.startDateAfterEndDate = true
          }
        }
      }
    }
  }

  ensureHiddenFieldsHaveNoValidation (): void {
    const fieldsToCheck = [
      { show: this.showExamBoard(), field: 'examBoardName' },
      { show: true, field: 'testType' },
      { show: this.showTestDate(), field: 'testTakenDate' },
      { show: this.showOverallScore(), field: 'overallScore' },
      { show: this.showOtherInstitution(), field: 'other_institutionName' },
      { show: this.showInstitution() && !this.isUgQualification, field: 'institutionName' },
      { show: this.showMajorSubjects() && !this.isUgQualification, field: 'majorSubjects' },
      { show: this.showApplicableGrade(), field: 'applicableGrade' },
      { show: this.showHonoursAndPassScore() && !this.isUgQualification, field: 'isHonoursDegree' },
      { show: this.showHonoursAndPassScore() && !this.isUgQualification && this.selectedStudyCountryCode === 'IND', field: 'numberOfBacklogsOrRetakes' },
      { show: this.showHonoursAndPassScore() && !this.isUgQualification && this.selectedStudyCountryCode === 'IND', field: 'numberOfBacklogsRetakesInLast2Years' }
    ]
    const hiddenFields = fieldsToCheck.filter(f => !f.show).map(f => f.field)
    this.formFieldHelper.clearValidatorsAndUpdate(this.academicDetailsForm, hiddenFields)

    // Restore validators for visible backlogs fields based on PP mandatory flag
    if (this.showHonoursAndPassScore() && !this.isUgQualification && this.selectedStudyCountryCode === 'IND') {
      this.restoreBacklogsValidators()
    }
    // Restore validator for honours degree when visible
    if (this.showHonoursAndPassScore() && !this.isUgQualification) {
      const honoursQ = this.questions?.find((q: any) => q.mappingField === 'isHonoursDegree')
      if (honoursQ?.mandatory) {
        const ctrl = this.academicDetailsForm.get('isHonoursDegree')
        ctrl?.setValidators([Validators.required])
        ctrl?.updateValueAndValidity()
      }
    }

    // Ensure testTakenDate and overallScore have required validators when shown
    if (this.showTestDate()) {
      const testDateControl = this.academicDetailsForm.get('testTakenDate')
      if (testDateControl) {
        testDateControl.setValidators([Validators.required])
        testDateControl.updateValueAndValidity()
      }
    }
    if (this.showOverallScore()) {
      const overallScoreControl = this.academicDetailsForm.get('overallScore')
      if (overallScoreControl && this.testScoreConfig) {
        const validators: any[] = [Validators.required]
        if (this.testScoreConfig.min !== null) validators.push(Validators.min(this.testScoreConfig.min))
        if (this.testScoreConfig.max !== null) validators.push(Validators.max(this.testScoreConfig.max))
        overallScoreControl.setValidators(validators)
        overallScoreControl.updateValueAndValidity()
      } else if (overallScoreControl) {
        overallScoreControl.setValidators([Validators.required])
        overallScoreControl.updateValueAndValidity()
      }
    }
  }

  getStorageKey (field: string, displayFormat?: string): string {
    if (field === 'testType' || field === 'testTakenDate' || field === 'overallScore') {
      return `academic_${field}`
    }
    if (field === 'institutionName' && displayFormat === 'TEXT_BOX') {
      return 'other_institutionName'
    }
    if (field === 'gradeType' || field === 'finalGrade') {
      return field
    }
    return field
  }

  backButton (): void {
    this.backClicked.emit()
    this.gtmImplementation.trackEvents('wir_academic_details', 'back_button', 'back', 'academic_details', 'signed_in_user', 'user_registration')
  }

  fetchCountryValues (countryValue: string): void {
    const payload = { country_3_code: countryValue }
    const cachedData = this.wirService.getStoredAcademicOptions(payload)

    if (cachedData?.data) {
      this.updateCountryOptions(cachedData.data)
      this.showQualificationType.set(true)
      return
    }

    this.wirService.getReferencedValues(payload).subscribe(
      (res: any) => {
        if (res?.data) {
          this.updateCountryOptions(res.data)
          this.showQualificationType.set(true)
        }
      },
      (error: any) => {
        console.error('Error fetching referenced values:', error)
      }
    )
  }

  fetchExamBoards (countryValue: string, qualificationId: string): void {
    const payload = { country_3_code: countryValue, country_qual_id: qualificationId }
    const cachedData = this.wirService.getStoredAcademicOptions(payload)
    if (cachedData?.data?.qual_exam_boards) {
      if (cachedData.data.qual_exam_boards.length > 0) {
        this.updateExamBoardOptions(cachedData.data.qual_exam_boards)
        this.showExamBoard.set(true)
        const examBoardQuestion = this.questions?.find((q: any) => q.mappingField === 'examBoardName')
        if (examBoardQuestion?.mandatory) {
          this.academicDetailsForm.get('examBoardName')?.setValidators([Validators.required])
        }
        this.academicDetailsForm.get('examBoardName')?.updateValueAndValidity()
      } else {
        this.showExamBoard.set(false)
        this.academicDetailsForm.get('examBoardName')?.clearValidators()
        this.academicDetailsForm.get('examBoardName')?.updateValueAndValidity()
        this.fetchGradeTypes(countryValue, qualificationId, 'GLO')
      }
      return
    }

    this.wirService.getReferencedValues(payload).subscribe(
      (res: any) => {
        if (res?.data?.qual_exam_boards) {
          if (res.data.qual_exam_boards.length > 0) {
            this.updateExamBoardOptions(res.data.qual_exam_boards)
            this.showExamBoard.set(true)
            const examBoardQ = this.questions?.find((q: any) => q.mappingField === 'examBoardName')
            if (examBoardQ?.mandatory) {
              this.academicDetailsForm.get('examBoardName')?.setValidators([Validators.required])
            }
            this.academicDetailsForm.get('examBoardName')?.updateValueAndValidity()
          } else {
            this.showExamBoard.set(false)
            this.academicDetailsForm.get('examBoardName')?.clearValidators()
            this.academicDetailsForm.get('examBoardName')?.updateValueAndValidity()
            this.fetchGradeTypes(countryValue, qualificationId, 'GLO')
          }
        }
      },
      (error: any) => {
        console.error('Error fetching exam boards:', error)
      }
    )
  }

  fetchGradeTypes (countryValue: string, qualificationId: string, examBoardId: string): void {
    const payload = { country_3_code: countryValue, country_qual_id: qualificationId, qual_exam_board_id: examBoardId }
    const cachedData = this.wirService.getStoredAcademicOptions(payload)
    if (cachedData?.data) {
      this.updateGradeTypeOptions(cachedData.data)
      this.showGradeType.set(true)
      return
    }

    this.wirService.getReferencedValues(payload).subscribe(
      (res: any) => {
        if (res?.data) {
          this.updateGradeTypeOptions(res.data)
          this.showGradeType.set(true)
        }
      },
      (error: any) => {
        console.error('Error fetching grade types:', error)
      }
    )
  }

  updateCountryOptions (data: any): void {
    if (data.institutions) {
      const institutionField = this.questions?.find((q: any) => q.mappingField === 'institutionName')
      if (institutionField) {
        const institutionOptions = data.institutions.map((inst: any) => ({
          option_label: inst.institution_name,
          option_value: inst.institution_id
        }))
        this.allOptions['institutionName'] = institutionOptions
        this.filteredOptions['institutionName'].next(institutionOptions)
      }
    }
    if (data.qualifications) {
      const qualificationField = this.questions?.find((q: any) => q.mappingField === 'qualificationType')
      if (qualificationField) {
        const qualificationOptions = data.qualifications.map((qual: any) => ({
          option_label: qual.country_qual_type_alias,
          option_value: qual.qual_id,
          country_qual_id: qual.country_qual_id,
          study_level_id: qual.study_level_id
        }))
        this.allOptions['qualificationType'] = qualificationOptions
        this.filteredOptions['qualificationType'].next(qualificationOptions)
      }
    }
  }

  updateExamBoardOptions (examBoards: any[]): void {
    const examBoardField = this.questions?.find((q: any) => q.mappingField === 'examBoardName')
    if (examBoardField) {
      const examBoardOptions = examBoards.map((board: any) => ({
        option_label: board.exam_board_name,
        option_value: board.exam_board_id,
        qual_exam_board_id: board.qual_exam_board_id
      }))
      this.allOptions['examBoardName'] = examBoardOptions
      this.filteredOptions['examBoardName'].next(examBoardOptions)
    }
  }

  updateGradeTypeOptions (data: any): void {
    if (data.qual_exam_board_grades) {
      const gradeTypeField = this.questions?.find((q: any) => q.mappingField === 'gradeType')
      if (gradeTypeField) {
        const gradeTypeOptions = data.qual_exam_board_grades.map((grade: any) => ({
          option_label: grade.grade_type_name,
          option_value: grade.grade_type_code,
          qual_exam_board_grade_id: grade.qual_exam_board_grade_id,
          grade_id: grade.grade_id
        }))
        this.allOptions['gradeType'] = gradeTypeOptions
        this.filteredOptions['gradeType'].next(gradeTypeOptions)
      }
    }
  }

  fetchGradeDetails (countryValue: string, qualificationId: string, examBoardId: string, gradeId: string): void {
    const payload = { country_3_code: countryValue, country_qual_id: qualificationId, qual_exam_board_id: examBoardId, grade_id: gradeId }
    const cachedData = this.wirService.getStoredAcademicOptions(payload)
    if (cachedData?.data?.qual_exam_board_grades_values) {
      this.handleGradeValuesResponse(cachedData.data.qual_exam_board_grades_values)
      return
    }

    this.wirService.getReferencedValues(payload).subscribe(
      (res: any) => {
        if (res?.data?.qual_exam_board_grades_values) {
          this.handleGradeValuesResponse(res.data.qual_exam_board_grades_values)
        }
      },
      (error: any) => {
        console.error('Error fetching grade details:', error)
      }
    )
  }

  handleGradeValuesResponse (gradeValues: any[]): void {
    if (gradeValues.length > 0) {
      const firstGrade = gradeValues[0]
      if (firstGrade.min_value !== null && firstGrade.max_value !== null) {
        this.gradeInputType = 'input'
        this.gradeInputConfig = {
          min_value: firstGrade.min_value,
          max_value: firstGrade.max_value,
          interval: firstGrade.interval || 0.01,
          grade_value_id: firstGrade.grade_value_id || null
        }
      } else {
        this.gradeInputType = 'dropdown'
        const gradeOptions = gradeValues.map((grade: any) => ({
          option_label: grade.grade_val,
          option_value: grade.grade_value_id,
          qual_exam_board_grade_id: grade.qual_exam_board_grade_id,
          rank: grade.rank ?? null
        }))
        this.allOptions['finalGrade'] = gradeOptions
        if (this.filteredOptions['finalGrade']) {
          this.filteredOptions['finalGrade'].next(gradeOptions)
        }
      }
      this.showFinalGrade.set(true)
    }
  }

  getExamBoardId (): string | null {
    const examBoardValue = this.academicDetailsForm.get('examBoardName')?.value
    if (!examBoardValue) return null
    const selectedExamBoard = this.allOptions['examBoardName']?.find(
      (option: any) => option.option_label === examBoardValue
    )
    return selectedExamBoard?.qual_exam_board_id || null
  }

  getCountryCode (): string {
    const countryValue = this.academicDetailsForm.get('studyCountryName')?.value
    const countryField = this.questions?.find((q: any) => q.mappingField === 'studyCountryName')
    if (countryField?.options) {
      const selectedCountry = countryField.options.find(
        (option: any) => option.option_label === countryValue
      )
      if (selectedCountry?.option_value) {
        return selectedCountry.option_value
      }
    }
    // Fallback: check userInputService for stored option_value
    const storedValue = this.userInputService.getValue('studyCountryName')
    if (storedValue?.option_value) {
      return storedValue.option_value
    }
    return typeof countryValue === 'string' ? countryValue : countryValue?.option_value
  }

  getQualificationId (): string {
    const qualValue = this.academicDetailsForm.get('qualificationType')?.value

    const selectedQual = this.allOptions['qualificationType']?.find(
      (option: any) => option.option_label === qualValue
    )

    return selectedQual?.country_qual_id || qualValue
  }

  isAcademicTestNotTaken (): boolean {
    const stored = this.userInputService.getValue('academic_testType')
    return stored?.option_value === 'tt_17' || (stored?.option_desc || stored?.option_label)?.toLowerCase() === 'not taken'
  }

  updateTestScoreConfig (testName: string): void {
    if (!testName) {
      this.testScoreConfig = null
      return
    }
    const allTests = [...this.admissionTestNames]
    const selectedTest = allTests.find((test: any) => test.value === testName)
    if (selectedTest) {
      this.testScoreConfig = {
        min: selectedTest.min,
        max: selectedTest.max === 'infinity' ? null : selectedTest.max
      }
      const overallScoreControl = this.academicDetailsForm.get('overallScore')
      if (overallScoreControl) {
        const overallScoreQuestion = this.questions?.find((q: any) => q.mappingField === 'overallScore' && q.questionAttributeId === 2336)
        const validators: any[] = overallScoreQuestion?.mandatory ? [Validators.required] : []
        if (this.testScoreConfig.min !== null) {
          validators.push(Validators.min(this.testScoreConfig.min))
        }
        if (this.testScoreConfig.max !== null) {
          validators.push(Validators.max(this.testScoreConfig.max))
        }
        overallScoreControl.setValidators(validators)
        overallScoreControl.updateValueAndValidity()
      }
    } else {
      this.testScoreConfig = null
    }
  }

  scrollToTop (): void {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
 
  ngOnDestroy (): void {
    clearTimeout(this.scrollTimer)
  }
}
